module.exports = __webpack_public_path__ + "static/media/suitcase-rolling.865a9b65.svg";